import { FormGroup } from '@angular/forms';
import { DirectDebitForm } from './direct-debit-form.interface';

export type DirectDebitFormValue = ReturnType<
  FormGroup<DirectDebitForm>['getRawValue']
>;
